import React from 'react';
import { Card, StatCard } from '../ui/Card';
import { Button } from '../ui/Button';
import { activityFeed } from '../../data/sampleData';
import { TargetIcon, CalendarIcon, UsersIcon, HardDriveIcon, UserIcon, FileIcon, PlusIcon, BarChartIcon, UploadIcon, UserPlusIcon } from 'lucide-react';
export const Dashboard: React.FC = () => {
  return <div data-id="element-163">
      <h1 className="text-2xl font-bold text-gray-12 mb-8" data-id="element-164">Dashboard</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-165">
        <StatCard title="Active Pursuits" value="12" subtitle="+2 this week" icon={<TargetIcon size={20} data-id="element-167" />} data-id="element-166" />
        <StatCard title="Upcoming Deadlines" value="5" subtitle="3 this week" icon={<CalendarIcon size={20} data-id="element-169" />} data-id="element-168" />
        <StatCard title="Team Members" value="18" subtitle="+1 new" icon={<UsersIcon size={20} data-id="element-171" />} data-id="element-170" />
        <StatCard title="Storage Used" value="45GB" subtitle="75% full" icon={<HardDriveIcon size={20} data-id="element-173" />} data-id="element-172" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-174">
        <div className="lg:col-span-2" data-id="element-175">
          <Card data-id="element-176">
            <h2 className="text-lg font-semibold text-gray-12 mb-4" data-id="element-177">
              Recent Activity
            </h2>
            <div className="space-y-4" data-id="element-178">
              {activityFeed.map(activity => <div key={activity.id} className="flex items-start py-3 border-b border-gray-6 last:border-0" data-id="element-179">
                  <div className="h-8 w-8 rounded-full bg-indigo-3 flex items-center justify-center text-indigo-11 mr-3" data-id="element-180">
                    {activity.icon === 'user' && <UserIcon size={16} data-id="element-181" />}
                    {activity.icon === 'file' && <FileIcon size={16} data-id="element-182" />}
                    {activity.icon === 'target' && <TargetIcon size={16} data-id="element-183" />}
                    {activity.icon === 'message' && <UserIcon size={16} data-id="element-184" />}
                  </div>
                  <div className="flex-1" data-id="element-185">
                    <p className="text-sm text-gray-12" data-id="element-186">
                      <span className="font-medium" data-id="element-187">{activity.user}</span>{' '}
                      {activity.action}{' '}
                      <span className="font-medium" data-id="element-188">"{activity.target}"</span>
                    </p>
                    <p className="text-xs text-gray-10 mt-1" data-id="element-189">{activity.time}</p>
                  </div>
                </div>)}
            </div>
          </Card>
        </div>
        <div data-id="element-190">
          <Card data-id="element-191">
            <h2 className="text-lg font-semibold text-gray-12 mb-4" data-id="element-192">
              Quick Actions
            </h2>
            <div className="space-y-3" data-id="element-193">
              <Button fullWidth icon={<PlusIcon size={16} data-id="element-195" />} className="justify-start" data-id="element-194">
                New Pursuit
              </Button>
              <Button fullWidth variant="secondary" icon={<BarChartIcon size={16} data-id="element-197" />} className="justify-start" data-id="element-196">
                Analyze RFQ
              </Button>
              <Button fullWidth variant="secondary" icon={<UploadIcon size={16} data-id="element-199" />} className="justify-start" data-id="element-198">
                Upload Assets
              </Button>
              <Button fullWidth variant="secondary" icon={<UserPlusIcon size={16} data-id="element-201" />} className="justify-start" data-id="element-200">
                Invite Team Member
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </div>;
};